<br />

<div class="row w-100 mt-3 mx-0 justify-content-center mt-5">
  <div class="col-12 col-md-7 col-lg-8 my-auto px-5 order-md-1 order-2">
    <div class="title">
      {{ "Generate Resume" | translate }}
    </div>
    <div class="description">
      {{ "Build your brand-new resume in as little as 5 minutes" | translate }}
    </div>

    <button class="gradient-button" routerLink="/generatResumeSteps">
      {{ "Get Started Now" | translate }}
    </button>
  </div>
  <img
    class="col-6 col-md-5 col-lg-4 text-center p-0 order-md-2 order-1"
    src="../../../assets/img/generate-resume.png"
  />
</div>
<div class="m-5">
  <div class="title">
    {{ "The Professional Resume Maker and CV Builder" | translate }}
  </div>
  <div class="row">
    <div class="col-12 col-sm-6 col-md-4">
      {{
        "Up-Career is everything you need to create an online resume and make your next career move"
          | translate
      }}
    </div>

    <app-card
      *ngFor="let item of services"
      [color]="item.color"
      [img]="item.img"
      [title]="item.title"
      [description]="item.description"
    />
  </div>
</div>
<app-work-counter></app-work-counter>
<div class="text-center">
  <h3 class="title">
    {{ "Choose from 18 Professional Resume Templates" | translate }}
  </h3>
  <p class="mx-5">
    {{
      "Build your resume quickly and effortlessly. Up Career’s resume builder comes with beautifully designed, ATS-optimized resume templates to help you find your desired job faster. Start by choosing your template."
        | translate
    }}
  </p>
</div>

<p-carousel
  [value]="cvTempletes"
  [numVisible]="4"
  [numScroll]="1"
  [showIndicators]="false"
  [responsiveOptions]="responsiveOptions"
  dir="ltr"
>
  <ng-template let-item pTemplate="item">
    <img [src]="item" class="w-100 border-round" />
  </ng-template>
</p-carousel>
